(function(){
  var p = new URLSearchParams(location.search);
  if (p.get('static') === '1') return;
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('anim');
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  /* threshold 0 plus rootMargin statt threshold .25: Sektionen, die hoeher als
     vier Viewports sind, erreichen auf Telefonen nie 25 Prozent Sichtbarkeit,
     isIntersecting bleibt false und der Inhalt steht dauerhaft auf opacity .01.
     Gemessen am 03.09.2026 an der Kategorie-Seite (3.885 px hohe Sektion,
     375x812 = 20,9 Prozent). Mit threshold 0 zaehlt die Beruehrung, der
     negative Fussrand loest erst aus, wenn die Sektion wirklich im Blick ist. */
  }, {threshold:0, rootMargin:'0px 0px -12% 0px'});
  document.querySelectorAll('.s2, .s3, .s4, .s5, .s6, .s7, .s8b, .pdsec').forEach(function(s){ io.observe(s); });
})();
